export default "__VITE_ASSET__uOoswOXw__"